





















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountIcon
  }
})
export default class FileDetailNavigationDrawer extends Vue {
  @Prop(Boolean) public readonly isOpenPropertydrawer!: boolean;
  @Prop(String) public readonly objectName!: string;
  @Prop(String) public readonly objectType!: string;
  @Prop(String) public readonly objectSize!: string;
  @Prop(String) public readonly objectPath!: string;
  @Prop(String) public readonly objectOwner!: string;
  @Prop(Date) public readonly objectChangeDate!: Date;
  @Prop(String) public readonly objectChanger!: string;
  @Prop(String) public readonly objectOwnerIcon!: string;
  @Prop(String) public readonly objectChangerIcon!: string;
  private isSelectDetailTab: boolean = true;
  private isSelectHistoryTab: boolean = false;

  private showDetail(): void {
    this.isSelectDetailTab = true;
    this.isSelectHistoryTab = false;
  }

  private showHistory(): void {
    this.isSelectDetailTab = false;
    this.isSelectHistoryTab = true;
  }
}
